import React from 'react';
import classNames from 'classnames';
import { EnquiryQuestionType } from '../../../Business/components/EnquirySlider/utils';
import { getIsArrayEmpty } from 'utils';

import './ShowEnquiryAnswers.styles.scss';

type ShowEnquiryAnswersProps = {
  className?: string;
  enquiryQuestions: EnquiryQuestionType[];
};

const ShowEnquiryAnswers: React.FC<ShowEnquiryAnswersProps> = (props) => {
  const { className, enquiryQuestions } = props;

  const classes = classNames('show-enquiry-answers', className);

  if (getIsArrayEmpty(enquiryQuestions)) return null;

  return (
    <div className={classes}>
      {enquiryQuestions.map(({ title, answer }) => (
        <div key={title}>
          <p>{title}</p>
          <p>{answer}</p>
        </div>
      ))}
    </div>
  );
};

export default ShowEnquiryAnswers;
